import { CSSProperties, FC, MutableRefObject, ReactElement, ReactNode } from 'react';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

import { useDialog } from '../Dialog/useDialog';
import './TitleToolbar.scss';

interface TitleToolbarProps {
  id?: string;
  className?: string;
  text: string | ReactElement;
  titleTagStyle?: CSSProperties;
  size?: 'sm' | 'md' | 'lg';
  action?: ReactNode;
  divRef?: MutableRefObject<HTMLDivElement | null>;
  renderAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  infoButton?: {
    title: string;
    text: string;
  };
}
export const TitleToolbar: FC<TitleToolbarProps> = ({
  id,
  className = '',
  size = 'lg',
  text,
  titleTagStyle,
  action,
  divRef,
  infoButton,
  renderAs: Tag = 'h1',
}) => {
  const { openAlertDialog } = useDialog();

  return (
    <div
      id={id}
      ref={divRef}
      className={`title-toolbar title-toolbar-size-${size} d-flex justify-content-between align-items-center ${className}`}
    >
      <Tag className="title" style={titleTagStyle}>
        {infoButton ? (
          <div className="d-flex gap-2 align-items-center">
            <div>{text}</div>
            <div onClick={() => openAlertDialog(infoButton)} className="info-button">
              <FontAwesomeIcon name="info-circle" />
            </div>
          </div>
        ) : (
          text
        )}
      </Tag>
      {action && <div className="title-action text-nowrap">{action}</div>}
    </div>
  );
};
